import React from 'react'
import { Box } from '@chakra-ui/react'
import RichContent from '../../uielements/RichContent/richContent'
import { useTranslation } from 'react-i18next'

const PageBody = ({ page }) => {
    const { i18n } = useTranslation()

    return (
        page?.body && (
            <Box py={[2,2,4,8, 16]} px={[2, 2, 4, 12, 36]}
                 sx={{
                     // columnCount: { base: 1, md: 2, lg: 2, xl: 2, '2xl': 2 },
                     columnGap: '20px',
                 }} lineHeight={1.7}>
                <RichContent body={page.body} locale={i18n.language} />
            </Box>
        )
    )
}

export default PageBody
